import { Utils } from '@everyboard/lib';
export class KamisadoColor {
    value;
    name;
    rgb;
    static ANY = new KamisadoColor(0, 'any', '#000');
    static ORANGE = new KamisadoColor(1, 'orange', '#d67421');
    static BLUE = new KamisadoColor(2, 'blue', '#006bac');
    static PURPLE = new KamisadoColor(3, 'purple', '#6f3787');
    static PINK = new KamisadoColor(4, 'pink', '#d2719e');
    static YELLOW = new KamisadoColor(5, 'yellow', '#e2c200');
    static RED = new KamisadoColor(6, 'red', '#d23339');
    static GREEN = new KamisadoColor(7, 'green', '#009157');
    static BROWN = new KamisadoColor(8, 'brown', '#562500');
    static of(value) {
        switch (value) {
            case 0: return KamisadoColor.ANY;
            case 1: return KamisadoColor.ORANGE;
            case 2: return KamisadoColor.BLUE;
            case 3: return KamisadoColor.PURPLE;
            case 4: return KamisadoColor.PINK;
            case 5: return KamisadoColor.YELLOW;
            case 6: return KamisadoColor.RED;
            case 7: return KamisadoColor.GREEN;
            default:
                Utils.expectToBe(value, 8, 'Invalid value ' + value + ' for KamisadoColor');
                return KamisadoColor.BROWN;
        }
    }
    constructor(value, name, rgb) {
        this.value = value;
        this.name = name;
        this.rgb = rgb;
    }
}
